<!-- Created by Kalpesh on 25-8-2021 -->

<div style="overflow:initial;height:100%">

    <div class="container">
        <label i18n="@@spmsUserReg" class="textColour">About</label>

        <div class="row topRowMargins text-center" style="margin-top: 30px;">
            <div class="col-lg-12">
                <h6 style="font-weight: 500;">JSuite Safety 1.0</h6>
            </div>
        </div>

        <div class="row topRowMargins">
            <div class="col-lg-2">

            </div>
            <div class="col-lg-4">
                <p style="font-weight: bold;">
                    Edition
                </p>
            </div>
            <div class="col-lg-4">
                <p>
                    Standard
                </p>
            </div>
        </div>

        <div class="row topRowMargins">
            <div class="col-lg-2">

            </div>
            <div class="col-lg-4">
                <p style="font-weight: bold;">
                  JSuite Version
                </p>
            </div>
            <div class="col-lg-4">
                <p>
                  {{ jsuiteVersion }}
                </p>
              </div> 
                           
        </div>
        <div class="row topRowMargins">
            <div class="col-lg-2">

            </div>
            <div class="col-lg-4">
                <p style="font-weight: bold;">
                  Environment
                </p>
            </div>
            <div class="col-lg-4">
                <p>
                  {{ jsuiteEnv }}
                </p>
              </div> 
                           
        </div>
        <div *ngIf="properties.length > 0">
            <div class="row topRowMargins" *ngFor="let property of properties">
              <div class="col-lg-2"></div>
              <div class="col-lg-4">
                <p style="font-weight: bold;">
                  {{ property.applicationname }}
                </p>
              </div>
              <div class="col-lg-4">
                <p>
                  {{ property.version }}
                </p>
              </div>
            </div>
          </div>
          
     
          
          
        

        <div class="row topRowMargins">
            <div class="col-lg-2">

            </div>
            <div class="col-lg-4">
                <p style="font-weight: bold;">
                    Release Notes
                </p>
            </div>
            <div class="col-lg-4">
                <a href="https://jeevlife.atlassian.net/wiki/spaces/JTRANSFORM/pages/edit-v2/204111955?draftShareId=75d92cba-2760-4e12-81d5-9e7e9911d1c4" target="_blank">Release Notes</a>
            </div>
        </div>

        <div class="row topRowMargins">
            <div class="col-lg-2">

            </div>
            <div class="col-lg-4">
                <p style="font-weight: bold;">
                    Product document
                </p>
            </div>
            <div class="col-lg-4">
              <a [href]="jsuiteHelpUrl" target="_blank">User Guide Link</a>
            </div>
        </div>

        <div class="row topRowMargins text-center">
            <div class="col-lg-12">
                <button i18n="@@TMRunButton" type="button" (click)="close()" class="actionButton btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
              style="padding-left:1.2rem;padding-right: 1.2rem; width: 20vh;" [style.background-color]="backgroundColorButton" [class.allocateButtons]="allocateButtonsBoolean" [class.allocateButtons1]="allocateButtons1Boolean">Ok</button>
            </div>
        </div>

    </div>
</div>
